import React from 'react';
import { Item } from './styles';
import { formatTimestamp, formatValue } from './utils';

export default function Environment({ data }) {
  if (!data) return null;

  return (
    <Item>
      <h3 style={{ marginBlockEnd: 0 }}>Environment</h3>
      {Object.entries(data).map(([device_id, d]) => (
        <div key={d.id || d.timestamp}>
          {formatTimestamp(d.timestamp)}
          <p style={{ marginLeft: '1em' }}>
            Pressure: {formatValue(d.pressure / 1000, 2)} bar<br />
            Temperature: {formatValue(d.temperature, 1)} °C<br />
            Humidity: {formatValue(d.humidity, 1)} %RH<br />
          </p>
        </div>
      ))}
    </Item>
  );
}
